export default "__VITE_ASSET__BVUCkL4D__"